import { Fetcher } from 'swr';

interface FetcherKey {
  method?: string;
  url: string;
  body?: Record<string, any>;
}

export const swrFetcher: Fetcher<any, FetcherKey> = async ({
  method = 'GET',
  url,
  body,
}) => {
  const response = await fetch(url, {
    method,
    ...(body ? { body: JSON.stringify(body) } : {}),
    headers: {
      'content-type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(response.statusText);
  }
  return await response.json();
};
